
const digest = 'e69f1e0b3bda45662417c30880c80ecba117b7dcac8ca824e3673937dbe18ee4';
const classes = {"wrapper":"_wrapper_183zy_1"};
const css = `._wrapper_183zy_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_183zy_1 a {
  color: #1665d8;
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  